export const deliveryObject = {
  token: '',
  delivery_file: '',
  companyName: '',
  nip: '',
  street: '',
  streetNumber: '',
  localNumber: '',
  city: '',
  zipCode: '',
  companyPhone: '',
  personOneName: '',
  personOneSurname: '',
  personOnePhone: '',
  personSecondName: '',
  personSecondSurname: '',
  personSecondPhone: '',
};
